import { render, staticRenderFns } from "./ReiseDatenDetails.vue?vue&type=template&id=53f65874&scoped=true"
import script from "./ReiseDatenDetails.vue?vue&type=script&lang=ts"
export * from "./ReiseDatenDetails.vue?vue&type=script&lang=ts"
import style0 from "./ReiseDatenDetails.vue?vue&type=style&index=0&id=53f65874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f65874",
  null
  
)

export default component.exports